import gql from 'graphql-tag';

export const LastEditedVersionFragment = gql`
	fragment LastEditedVersionFragment on Version {
		by {
			displayName
		}
		when
	}
`;

export const LastEditedDraftVersionFragment = gql`
	fragment LastEditedDraftVersionFragment on Version {
		by {
			displayName
		}
		when
	}
`;
